<template>
  <div
    class="video-suggestions card"
    :class="{ 'video-suggestions--dark': dark }"
  >
    <p class="card-header-title is-unselectable">Więcej materiałów</p>
    <div class="video-suggestions__switch">
      <div class="tabs is-centered is-boxed is-small">
        <ul>
          <li
            :class="{ 'is-active': videoSuggestionsSource === Source.TAGS }"
            @click="switchVideoSuggestions(Source.TAGS)"
          >
            <a>
              <icon name="fa-tag" />
              <span>Powiązane</span>
            </a>
          </li>
          <li
            :class="{
              'is-active': videoSuggestionsSource === Source.OLDER,
              disabled: suggestions.older.length === 0
            }"
            @click="switchVideoSuggestions(Source.OLDER)"
          >
            <a>
              <icon name="fa-clock" />
              <span>Ostatnie</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <div
        class="video-suggestions__list card-content"
        :key="videoSuggestionsSource"
      >
        <video-item
          v-for="suggestion in selectedSuggestions"
          :key="suggestion.id"
          :video="suggestion"
          :dark="dark"
          @click="$emit('click-item', $event)"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { Icon } from "%helpers";
import VideoItem from "./VideoItem";

const Source = {
  TAGS: 0,
  OLDER: 1
};

export default {
  name: "video-suggestions",

  components: {
    Icon,
    VideoItem
  },

  data() {
    return {
      videoSuggestionsSource: Source.TAGS,

      Source
    };
  },

  props: {
    suggestions: Object,
    dark: Boolean
  },

  computed: {
    selectedSuggestions() {
      return {
        [Source.TAGS]: this.suggestions.relatedByTags,
        [Source.OLDER]: this.suggestions.older
      }[this.videoSuggestionsSource];
    }
  },

  methods: {
    switchVideoSuggestions(source) {
      this.videoSuggestionsSource =
        source === Source.OLDER && this.suggestions.older.length > 0
          ? Source.OLDER
          : Source.TAGS;
    }
  },

  watch: {
    "suggestions.older"(older) {
      if (older.length === 0) {
        this.videoSuggestionsSource = Source.TAGS;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.video-suggestions {
  &__switch {
    padding-top: 1.5rem;

    .tabs ul .disabled {
      cursor: not-allowed;

      a {
        cursor: not-allowed;

        span {
          color: $grey-lighter;
        }
      }

      &:hover,
      a:hover,
      &.is-active a {
        background: transparent;
        border-color: transparent;
      }
    }
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    padding: 0.5rem;

    .video-item {
      @include desktop {
        width: 100%;
      }

      @include touch {
        width: 50%;
      }

      @include until($small-mobile) {
        width: 100%;
      }
    }
  }

  &--dark {
    background: $grey-darker;

    .card-header-title {
      color: $grey-lighter;
    }

    .video-suggestions {
      &__switch .tabs {
        ul {
          border-bottom-color: $grey-dark;

          .is-active a {
            border-color: $grey-dark;
            background: $grey-darker;
            color: $white;
          }

          .is-active:hover a {
            background: $grey-darker;
          }

          a {
            color: $grey;
          }

          li:hover a {
            background: $grey-dark;
            border-color: $grey-dark;
          }

          .disabled {
            cursor: not-allowed;

            a span {
              color: $grey-dark;
            }

            &:hover,
            a:hover,
            &.is-active a {
              background: transparent;
              border-color: transparent;
            }
          }
        }
      }
    }
  }
}
</style>
